module.exports = __webpack_public_path__ + "img/to_sudoku_en.2549de9c.png";